// extracted by mini-css-extract-plugin
export var button = "_5g-7";
export var buttonRow = "_5g-6";
export var fadeIn = "_5g-1";
export var gradient = "_5g-0";
export var panel = "_5g-2";
export var panelIn = "_5g-3";
export var subtitle = "_5g-5";
export var title = "_5g-4";